import { render, staticRenderFns } from "./unclaimed.vue?vue&type=template&id=7d1cd6eb&scoped=true&"
import script from "./unclaimed.vue?vue&type=script&lang=js&"
export * from "./unclaimed.vue?vue&type=script&lang=js&"
import style0 from "./unclaimed.vue?vue&type=style&index=0&id=7d1cd6eb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1cd6eb",
  null
  
)

export default component.exports